import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IRetailerBoard) {
    (function(IItem) {
        IItem.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IRetailerBoard.IItem || (IRetailerBoard.IItem = {}));
    (function(IRetailerInfo) {
        IRetailerInfo.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IRetailerBoard.IRetailerInfo || (IRetailerBoard.IRetailerInfo = {}));
    (function(BoardType) {
        BoardType["DEFAULT"] = "DEFAULT";
        BoardType["MY_BOARD"] = "MY_BOARD";
        BoardType["OTHER"] = "OTHER";
        BoardType["BOARD_SUGGESTION"] = "BOARD_SUGGESTION";
    })(IRetailerBoard.BoardType || (IRetailerBoard.BoardType = {}));
    (function(BoardItemType) {
        BoardItemType["BOARD_ITEM_TYPE_UNKNOWN"] = "BOARD_ITEM_TYPE_UNKNOWN";
        BoardItemType["PRODUCT_ONLY"] = "PRODUCT_ONLY";
        BoardItemType["BRAND_ONLY"] = "BRAND_ONLY";
    })(IRetailerBoard.BoardItemType || (IRetailerBoard.BoardItemType = {}));
    IRetailerBoard.build = function(partial) {
        return _object_spread({
            cover_images: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IRetailerBoard || (IRetailerBoard = {}));
export var IRetailerBoard;
